"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePartialIUserDataEntityDefaultFilters = void 0;
const partial_iuser_data_entity_default_filters_planning_item_search_filter_1 = require("./partial-iuser-data-entity-default-filters-planning-item-search-filter");
const partial_iuser_data_entity_default_filters_work_order_search_filter_1 = require("./partial-iuser-data-entity-default-filters-work-order-search-filter");
function parsePartialIUserDataEntityDefaultFilters(data) {
    if (data.workOrderSearchFilter !== null && typeof data.workOrderSearchFilter === 'object')
        data.workOrderSearchFilter = (0, partial_iuser_data_entity_default_filters_work_order_search_filter_1.parsePartialIUserDataEntityDefaultFiltersWorkOrderSearchFilter)(data.workOrderSearchFilter);
    if (data.planningItemSearchFilter !== null && typeof data.planningItemSearchFilter === 'object')
        data.planningItemSearchFilter = (0, partial_iuser_data_entity_default_filters_planning_item_search_filter_1.parsePartialIUserDataEntityDefaultFiltersPlanningItemSearchFilter)(data.planningItemSearchFilter);
    return data;
}
exports.parsePartialIUserDataEntityDefaultFilters = parsePartialIUserDataEntityDefaultFilters;
